import { render, staticRenderFns } from "./DocumentTypeCard.vue?vue&type=template&id=84d28db6&scoped=true"
import script from "./DocumentTypeCard.vue?vue&type=script&lang=js"
export * from "./DocumentTypeCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypeCard.vue?vue&type=style&index=0&id=84d28db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d28db6",
  null
  
)

export default component.exports